import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import * as steps from 'common/steps';
import {
  isStepCompleted,
  isStepActive,
  doesStepHaveErrors,
} from 'common/selectors';
import { SET_ACTIVE_STEP } from 'submission/submissionActions';
import StepMenuItem from 'general-components/StepMenuItem';

const FileUploadMenuItem = ({ active, completed, error, number, onClick }) =>
  <StepMenuItem
    key={steps.FILE_UPLOAD}
    number={number}
    active={active}
    completed={completed}
    error={error}
    label="File Upload"
    onClick={onClick}
  />;

const mapState = R.applySpec({
  active: isStepActive(steps.FILE_UPLOAD),
  completed: isStepCompleted(steps.FILE_UPLOAD),
  error: doesStepHaveErrors(steps.FILE_UPLOAD),
});

const mapDispatch = dispatch => ({
  onClick: () => dispatch({ type: SET_ACTIVE_STEP, step: steps.FILE_UPLOAD }),
});

export default connect(mapState, mapDispatch)(FileUploadMenuItem);



// WEBPACK FOOTER //
// ./src/file-upload/components/FileUploadMenuItem.js